import { getAppConfig } from '../hooks/useAppConfig';

const SERVER = getAppConfig('server');
export function url(path) {
  return `${SERVER}${path}`;
}

export const MAIN_WEBSITE_URL = window.app.ui?.WEBEIX_HOST;
